import { render, staticRenderFns } from "./FilterPill.vue?vue&type=template&id=c2e4aa02&scoped=true"
import script from "./FilterPill.vue?vue&type=script&lang=js"
export * from "./FilterPill.vue?vue&type=script&lang=js"
import style0 from "./FilterPill.vue?vue&type=style&index=0&id=c2e4aa02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2e4aa02",
  null
  
)

export default component.exports